import React from 'react';
import styles from './EnTete.module.scss';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import EnTeteProfil from './EnTeteProfil/EnTeteProfil';
import EnTeteParametre from './EnTeteParametre/EnTeteParametre';
import Aide from './Aide/Aide';

const enTete = () => {
  return (
    <div className={[s.row, s.justify_content_center].join(' ')}>
      <div className={[styles.BoutonEnTete].join(' ')}>
        <EnTeteProfil />
      </div>
      <div className={styles.BoutonEnTete}>
        <EnTeteParametre />
      </div>
      <div className={styles.BoutonEnTete}>
        <Aide />
      </div>
    </div>
  );
};
export default enTete;
